import React from 'react';
import styles from './CartItem.module.scss';
import ItemButtons from '../ItemButtons/ItemButtons';
import QuantityInput from '../QuantityInput/QuantityInput';
import ItemPrice from '../ItemPrice/ItemPrice';

interface CartItemProps {
  item: {
    handle: string;
    variant_id: string;
    key: string;
    featured_image: {
      url: string;
      alt: string;
    };
    product_title: string;
    variant_title?: string;
    properties: {
      bundle_builder?: string;
      _isFreeGift?: string;
      empty_cart_url?: string;
      [key: string]: string | undefined;
    };
    id: number;
    quantity: number;
  };
}

export default function CartItem({ item }: CartItemProps) {
  const excludeProperties = ["_compare_at_price", "t", "Type", "custom_key", "o", "i", "_isFreeGift", "_minCartPrice", "_maxCartPrice", "bundle_id", "bundle_builder"];
  const excludeProductIds = [47696130867433];
  const redirectUrl = `/products/${item.handle}?variant=${item.variant_id}&key=${item.key}`;

  return (
    <div className={styles.cartItem}>
      <a href={item.properties.bundle_builder !== "yes" && !item.properties._isFreeGift ? `/products/${item.handle}` : "#"}>
        <img
          className={styles.itemImage}
          src={item.featured_image.url}
          alt={item.featured_image.alt}
          loading="lazy"
        />
      </a>
      <div className={styles.itemDetails}>
        <a href={item.properties.bundle_builder !== "yes" && !item.properties._isFreeGift ? `/products/${item.handle}` : "#"}>
          <h1>{item.product_title}</h1>
        </a>
        {item?.properties && (
          <div className={styles.properties}>
            {
              item?.variant_title && (
                <p key={"Style"}>Style: {item.variant_title}</p>
              )
            }
            {item.properties.bundle_builder && (
              <p key={"Bundle Builder"}><b>Bundle Product</b></p>
            )}
            {Object.entries(item.properties).map(([key, value]) => {
              if (!excludeProperties.includes(key)) {
                const cleanedValue = typeof value === 'string' ? value.replace(/\[.*?\]/g, '') : value;
                return <p key={key}>{key}: {cleanedValue}</p>;
              }
              return null;
            })}
          </div>
        )}
        {(!item.properties._isFreeGift && !excludeProductIds.includes(item.id)) && (
          <QuantityInput cartKey={item.key} quantity={item.quantity} />
        )}
        {excludeProductIds.includes(item.id) && (
          <p className={styles.limitedOffer}>Limited Offer - One Per Customer Only.</p>
        )}
      </div>
      <div className={styles.itemControls}>
        <ItemButtons cartKey={item.key} redirectUrl={redirectUrl} freeGift={item.properties._isFreeGift} emptyCartUrl={item.properties.empty_cart_url} bundleBuilder={item.properties.bundle_builder} />
        <ItemPrice cartKey={item.key} />
      </div>
    </div>
  );
}

CartItem.displayName = "CartItem";
